<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "SOLICITAR" : "ACTUALIZAR" }} SERVICIO</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

        <!-- SELECCIONAR ID SERVICE -->
        <div class="vx-row">
          <div class="vx-col w-full mt-2">
            <label class="vs-input--label" >Elija un servicio de Extranjería</label>
            <v-select :closeOnSelect="true" v-model="id_service" label="name_service" :options="services" name="id_service" :reduce=" services => services.id_service "></v-select>
          </div>
        </div>

        <!-- CLIENT AVAILABILITY -->
        <div class="vx-row" v-if="this.id_service">
          <div class="vx-col w-full mt-2">
            <label class="vs-input--label">Si desea enviar alguna nota con la solitud, escríbala a continuación:</label>            
            <vs-textarea v-model="client_comment" placeholder="" rows="3"></vs-textarea>
          </div>
        </div>

    </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ingresar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        this.initValues()
      }
    }
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      id_service: null,
      client_comment: null
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    services () {
      return this.$store.state.services.filter(item => item.type_service === 'Inmigration')
    },
    isFormValid () {
      return !this.errors.any() && (this.type_of_request !== null) && this.id_service 
    }
  },
  methods: {
    initValues () {
      if (this.data.id_client_request) return
      this.id_service = null
      this.client_comment = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            service_id: this.id_service,
            client_comment: this.client_comment
          }
          this.$vs.loading()
          this.$store.dispatch('addClientRequest', obj)
            .then(() => { this.$emit('closeSidebar') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Solicitud enviada',
                text: 'Usted ha realizado una solicitud de servicio',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check'
              }) 
            })
            .then(() => { this.initValues() })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              if (typeof mensaje_error === 'string') {
                this.$vs.notify({
                  title: 'Error',
                  text: `${mensaje_error}`,
                  color: 'warning',
                  iconPack: 'feather',
                  icon:'icon-x-circle',
                  time: 6000
                })
              } else {
                const array_errors = Object.entries(mensaje_error)
                for (let i = 0; i < array_errors.length; i++) {
                  this.$vs.notify({
                    title: 'Error',
                    text: `${array_errors[i][1][0]}`,
                    iconPack: 'feather',
                    icon: 'icon-x-circle',
                    color: 'warning',
                    time: 6000
                  })
                }
              }
            })
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
